!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define("guineaSubdivision", [], r) : "object" == typeof exports ? exports.guineaSubdivision = r() : e.guineaSubdivision = r();
}(this, function () {
  return function (e) {
    function r(o) {
      if (u[o]) return u[o].exports;
      var s = u[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    var u = {};
    return r.m = e, r.c = u, r.d = function (e, u, o) {
      r.o(e, u) || Object.defineProperty(e, u, {
        enumerable: !0,
        get: o
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, u) {
      if (1 & u && (e = r(e)), 8 & u) return e;
      if (4 & u && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & u && "string" != typeof e) for (var s in e) r.d(o, s, function (r) {
        return e[r];
      }.bind(null, s));
      return o;
    }, r.n = function (e) {
      var u = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(u, "a", u), u;
    }, r.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, r.p = "", r(r.s = 0);
  }([function (e, r) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var u = [{
        code: "GN-C",
        region: "Conakry"
      }, {
        code: "GN-L",
        region: "Labé"
      }, {
        code: "GN-K",
        region: "Kankan"
      }, {
        code: "GN-F",
        region: "Faranah"
      }, {
        code: "GN-M",
        region: "Mamou"
      }, {
        code: "GN-D",
        region: "Kindia"
      }, {
        code: "GN-B",
        region: "Boké"
      }, {
        code: "GN-N",
        region: "N'Zérékoré"
      }],
      o = [{
        comment: "-----------les prefectures de conakry------------",
        regionCode: "GN-C",
        prefectureCode: "CONA",
        prefecture: "Conakry"
      }, {
        regionCode: "GN-L",
        prefectureCode: "KOUB",
        prefecture: "Koubia"
      }, {
        regionCode: "GN-L",
        prefectureCode: "LABE",
        prefecture: "Labé"
      }, {
        regionCode: "GN-L",
        prefectureCode: "LELO",
        prefecture: "Lélouma"
      }, {
        regionCode: "GN-L",
        prefectureCode: "MALI",
        prefecture: "Mali"
      }, {
        regionCode: "GN-L",
        prefectureCode: "TOUG",
        prefecture: "Tougué"
      }, {
        comment: "--------- les prefectures de kankan -----------",
        regionCode: "GN-K",
        prefectureCode: "KANK",
        prefecture: "Kankan"
      }, {
        regionCode: "GN-K",
        prefectureCode: "KERO",
        prefecture: "Kérouane"
      }, {
        regionCode: "GN-K",
        prefectureCode: "KOUR",
        prefecture: "Kouroussa"
      }, {
        regionCode: "GN-K",
        prefectureCode: "MAND",
        prefecture: "Mandiana"
      }, {
        regionCode: "GN-K",
        prefectureCode: "SIGU",
        prefecture: "Siguiri"
      }, {
        comment: "-------- les prefectures de faranah --------------",
        regionCode: "GN-F",
        prefectureCode: "DABO",
        prefecture: "Dabola"
      }, {
        regionCode: "GN-F",
        prefectureCode: "DING",
        prefecture: "Dinguiraye"
      }, {
        regionCode: "GN-F",
        prefectureCode: "FARA",
        prefecture: "Faranah"
      }, {
        regionCode: "GN-F",
        prefectureCode: "KISS",
        prefecture: "Kissidougou"
      }, {
        comment: "-------------- les prefectures de mamou ------------------",
        regionCode: "GN-M",
        prefectureCode: "MAMO",
        prefecture: "Mamou"
      }, {
        regionCode: "GN-M",
        prefectureCode: "DALA",
        prefecture: "Dalaba"
      }, {
        regionCode: "GN-M",
        prefectureCode: "PITA",
        prefecture: "Pita"
      }, {
        comment: "------------- les prefectures de kindia ----------",
        regionCode: "GN-D",
        prefectureCode: "COYA",
        prefecture: "Coyah"
      }, {
        regionCode: "GN-D",
        prefectureCode: "DUBR",
        prefecture: "Dubréka"
      }, {
        regionCode: "GN-D",
        prefectureCode: "FORE",
        prefecture: "Forécariah"
      }, {
        regionCode: "GN-D",
        prefectureCode: "KIND",
        prefecture: "Kindia"
      }, {
        regionCode: "GN-D",
        prefectureCode: "TELI",
        prefecture: "Télimélé"
      }, {
        comment: "------------------- les prefectures de boke ------------------",
        regionCode: "GN-B",
        prefectureCode: "BOFF",
        prefecture: "Boffa"
      }, {
        regionCode: "GN-B",
        prefectureCode: "BOKE",
        prefecture: "Boké"
      }, {
        regionCode: "GN-B",
        prefectureCode: "GAOU",
        prefecture: "Gaoual"
      }, {
        regionCode: "GN-B",
        prefectureCode: "KOUN",
        prefecture: "Koundara"
      }, {
        regionCode: "GN-B",
        prefectureCode: "FRIA",
        prefecture: "Fria"
      }, {
        comment: "------------- les prefectures de n'zerekore ----------",
        regionCode: "GN-N",
        prefectureCode: "BEYL",
        prefecture: "Beyla"
      }, {
        regionCode: "GN-N",
        prefectureCode: "GUEC",
        prefecture: "Guéckédou"
      }, {
        regionCode: "GN-N",
        prefectureCode: "LOLA",
        prefecture: "Lola"
      }, {
        regionCode: "GN-N",
        prefectureCode: "MACE",
        prefecture: "Macenta"
      }, {
        regionCode: "GN-N",
        prefectureCode: "NZER",
        prefecture: "Nzérékoré"
      }, {
        regionCode: "GN-N",
        prefectureCode: "YOMO",
        prefecture: "Yomou"
      }],
      s = [{
        comment: " --------------- conakry ---------------",
        prefectureCode: "CONA",
        sousprefectureCode: "MATO",
        sousprefecture: "Matoto"
      }, {
        prefectureCode: "CONA",
        sousprefectureCode: "RATO",
        sousprefecture: "Ratoma"
      }, {
        prefectureCode: "CONA",
        sousprefectureCode: "KALO",
        sousprefecture: "Kaloum"
      }, {
        prefectureCode: "CONA",
        sousprefectureCode: "DIXI",
        sousprefecture: "Dixinn"
      }, {
        prefectureCode: "CONA",
        sousprefectureCode: "MATA",
        sousprefecture: "Matam"
      }, {
        comment: " --------------- koubia ---------------",
        prefectureCode: "KOUB",
        sousprefectureCode: "FAFA",
        sousprefecture: "Fafaya"
      }, {
        prefectureCode: "KOUB",
        sousprefectureCode: "GADH",
        sousprefecture: "Gadha Woundou"
      }, {
        prefectureCode: "KOUB",
        sousprefectureCode: "KOUBC",
        sousprefecture: "Koubia centre"
      }, {
        prefectureCode: "KOUB",
        sousprefectureCode: "MATA",
        sousprefecture: "Matakaou"
      }, {
        prefectureCode: "KOUB",
        sousprefectureCode: "MISS",
        sousprefecture: "Missira"
      }, {
        prefectureCode: "KOUB",
        sousprefectureCode: "PILI",
        sousprefecture: "Pilimini"
      }, {
        comment: " --------------- Labe ---------------",
        prefectureCode: "LABE",
        sousprefectureCode: "LABE",
        sousprefecture: "Labé Centre"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "DALE",
        sousprefecture: "Dalein"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "DARA",
        sousprefecture: "Daralabé"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "DIAR",
        sousprefecture: "Diari"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "DION",
        sousprefecture: "Dionfo"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "GARA",
        sousprefecture: "Garambé"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "HAFI",
        sousprefecture: "Hafia"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "NOUS",
        sousprefecture: "Noussy"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "POPO",
        sousprefecture: "Popodara"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "SANN",
        sousprefecture: "Sannou"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "TOUN",
        sousprefecture: "Tountouroun"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "KALA",
        sousprefecture: "Kalan"
      }, {
        prefectureCode: "LABE",
        sousprefectureCode: "KOUR",
        sousprefecture: "Kouramangui"
      }, {
        comment: " --------------- Kankan ---------------",
        prefectureCode: "KANK",
        sousprefectureCode: "KANK",
        sousprefecture: "Kankan Centre"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "BALA",
        sousprefecture: "Balandougou"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "BARA",
        sousprefecture: "Baranama"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "BATE",
        sousprefecture: "Batè-Nafadji"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "BOUL",
        sousprefecture: "Boula"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "GBEN",
        sousprefecture: "Gbendou-Baranama"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "KARF",
        sousprefecture: "Karfamorya"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "KOUM",
        sousprefecture: "Koumban"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "NAMO",
        sousprefecture: "Mamouroudou"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "MISS",
        sousprefecture: "Missamana"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "MORI",
        sousprefecture: "Moribaya"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "TINT",
        sousprefecture: "Tintioulen"
      }, {
        prefectureCode: "KANK",
        sousprefectureCode: "TOKO",
        sousprefecture: "Tokounou"
      }, {
        comment: " --------------- Faranah ---------------",
        prefectureCode: "FARA",
        sousprefectureCode: "FARA",
        sousprefecture: "Faranah Centre"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "BANI",
        sousprefecture: "Banian"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "BIND",
        sousprefecture: "Bindougou"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "HERE",
        sousprefecture: "Hèrmakono"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "KOBI",
        sousprefecture: "Kobikoro"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "MARE",
        sousprefecture: "Maréla"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "NIAL",
        sousprefecture: "Nialia"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "PASS",
        sousprefecture: "Passaya"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "SAND",
        sousprefecture: "Sandénia"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "SANG",
        sousprefecture: "Songoya"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "TIRO",
        sousprefecture: "Tiro"
      }, {
        prefectureCode: "FARA",
        sousprefectureCode: "TIND",
        sousprefecture: "Tindo"
      }, {
        comment: " --------------- Kissidougou ---------------",
        prefectureCode: "KISS",
        sousprefectureCode: "ALB",
        sousprefecture: "Albadariah"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "YOM",
        sousprefecture: "Yombiro"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "YEN",
        sousprefecture: "Yende-Millimou"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "SAN",
        sousprefecture: "Sangardo"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "MAN",
        sousprefecture: "Manfran"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "KOUN",
        sousprefecture: "Koundiatou"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "KIS",
        sousprefecture: "kissidougou Centre"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "GBAN",
        sousprefecture: "Gbangbadou"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "BANA",
        sousprefecture: "Banama"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "BAR",
        sousprefecture: "Bardou"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "BEIN",
        sousprefecture: "Beindou"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "FER",
        sousprefecture: "Fermesadou"
      }, {
        prefectureCode: "KISS",
        sousprefectureCode: "FIRA",
        sousprefecture: "Firawa (Yomadou)"
      }, {
        comment: " --------------- Kerouane ---------------",
        prefectureCode: "KERO",
        sousprefectureCode: "BAN",
        sousprefecture: "Banankoro"
      }, {
        prefectureCode: "KERO",
        sousprefectureCode: "SORO",
        sousprefecture: "Soromaya"
      }, {
        prefectureCode: "KERO",
        sousprefectureCode: "SIBI",
        sousprefecture: "Sibiribaro"
      }, {
        prefectureCode: "KERO",
        sousprefectureCode: "LINK",
        sousprefecture: "Linko"
      }, {
        prefectureCode: "KERO",
        sousprefectureCode: "KOUN",
        sousprefecture: "Kounsankoro"
      }, {
        prefectureCode: "KERO",
        sousprefectureCode: "KOMO",
        sousprefecture: "Komodou"
      }, {
        prefectureCode: "KERO",
        sousprefectureCode: "KEROC",
        sousprefecture: "Kereouane centre"
      }, {
        prefectureCode: "KERO",
        sousprefectureCode: "DAMA",
        sousprefecture: "Damaro"
      }, {
        comment: " --------------- Kouroussa ---------------",
        prefectureCode: "KOUR",
        sousprefectureCode: "BAB",
        sousprefecture: "Babila"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "BAL",
        sousprefecture: "Balato"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "BAN",
        sousprefecture: "Banfele"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "BAR",
        sousprefecture: "Baro"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "CIS",
        sousprefecture: "Cissela"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "DOU",
        sousprefecture: "Douako"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "DOUR",
        sousprefecture: "Doura"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "KIN",
        sousprefecture: "Kiniero"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "KOM",
        sousprefecture: "Komola-Koura"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "KOUMA",
        sousprefecture: "Koumana"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "KOURO",
        sousprefecture: "Kouroussa centre"
      }, {
        prefectureCode: "KOUR",
        sousprefectureCode: "SAN",
        sousprefecture: "Sanguiana"
      }, {
        comment: " --------------- Boffa ---------------",
        prefectureCode: "BOFF",
        sousprefectureCode: "BOFF-CENT",
        sousprefecture: "Boffa centre"
      }, {
        prefectureCode: "BOFF",
        sousprefectureCode: "DROU",
        sousprefecture: "douprou"
      }, {
        prefectureCode: "BOFF",
        sousprefectureCode: "KOBA",
        sousprefecture: "koba-tatema"
      }, {
        prefectureCode: "BOFF",
        sousprefectureCode: "KOLI",
        sousprefecture: "kolia"
      }, {
        prefectureCode: "BOFF",
        sousprefectureCode: "LISS",
        sousprefecture: "lisso"
      }, {
        prefectureCode: "BOFF",
        sousprefectureCode: "MANK",
        sousprefecture: "mankountan"
      }, {
        prefectureCode: "BOFF",
        sousprefectureCode: "TAMI",
        sousprefecture: "tamita"
      }, {
        prefectureCode: "BOFF",
        sousprefectureCode: "TOUGN",
        sousprefecture: "tougnifili"
      }, {
        comment: " --------------- Boke ---------------",
        prefectureCode: "BOKE",
        sousprefectureCode: "BINTI",
        sousprefecture: "bintimodiya"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "BOKE-CENT",
        sousprefecture: "boké-centre"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "DABI",
        sousprefecture: "dabiss"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "KAMS",
        sousprefecture: "kamsar"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "KANF",
        sousprefecture: "kanfarandé"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "KOLA",
        sousprefecture: "kolaboui"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "MALAP",
        sousprefecture: "malapouyah"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "SANG",
        sousprefecture: "sangarédi"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "SANSA",
        sousprefecture: "sansalé"
      }, {
        prefectureCode: "BOKE",
        sousprefectureCode: "TANE",
        sousprefecture: "tanéné  boké"
      }, {
        comment: " --------------- Fria ---------------",
        prefectureCode: "FRIA",
        sousprefectureCode: "BAGUI",
        sousprefecture: "baguinet"
      }, {
        prefectureCode: "FRIA",
        sousprefectureCode: "BANGU",
        sousprefecture: "bangouyah"
      }, {
        prefectureCode: "FRIA",
        sousprefectureCode: "BANGUI",
        sousprefecture: "banguigny"
      }, {
        prefectureCode: "FRIA",
        sousprefectureCode: "FRIA-CENT",
        sousprefecture: "fria-centre"
      }, {
        prefectureCode: "FRIA",
        sousprefectureCode: "TORM",
        sousprefecture: "tormelin"
      }, {
        comment: " --------------- Gaoul ---------------",
        prefectureCode: "GAOU",
        sousprefectureCode: "FOULA",
        sousprefecture: "foulamory"
      }, {
        prefectureCode: "GAOU",
        sousprefectureCode: "GAOUL-CENT",
        sousprefecture: "gaoual-centre"
      }, {
        prefectureCode: "GAOU",
        sousprefectureCode: "KAKON",
        sousprefecture: "kakony"
      }, {
        prefectureCode: "GAOU",
        sousprefectureCode: "BANT",
        sousprefecture: "bantala"
      }, {
        prefectureCode: "GAOU",
        sousprefectureCode: "KOUMB",
        sousprefecture: "koumbia"
      }, {
        prefectureCode: "GAOU",
        sousprefectureCode: "KOUNS",
        sousprefecture: "kounsitel"
      }, {
        prefectureCode: "GAOU",
        sousprefectureCode: "MALAN",
        sousprefecture: "malanta"
      }, {
        prefectureCode: "GAOU",
        sousprefectureCode: "WEND",
        sousprefecture: "wendou m'bour"
      }, {
        comment: " --------------- Koundara ---------------",
        prefectureCode: "KOUN",
        sousprefectureCode: "GUING",
        sousprefecture: "guingan"
      }, {
        prefectureCode: "KOUN",
        sousprefectureCode: "KAMA",
        sousprefecture: "kamaby"
      }, {
        prefectureCode: "KOUN",
        sousprefectureCode: "KOUNDARA-CENT",
        sousprefecture: "koundara-centre"
      }, {
        prefectureCode: "KOUN",
        sousprefectureCode: "SAMB",
        sousprefecture: "sambailo"
      }, {
        prefectureCode: "KOUN",
        sousprefectureCode: "SARE",
        sousprefecture: "saréboido"
      }, {
        prefectureCode: "KOUN",
        sousprefectureCode: "TERM",
        sousprefecture: "termessé"
      }, {
        prefectureCode: "KOUN",
        sousprefectureCode: "YOUKO",
        sousprefecture: "youkounkoun"
      }, {
        comment: " --------------- Dabola ---------------",
        prefectureCode: "DABO",
        sousprefectureCode: "BANKO",
        sousprefecture: "banko"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "BISSI",
        sousprefecture: "bissikrima"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "DABOLA-CENT",
        sousprefecture: "dabola-centre"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "DOGO",
        sousprefecture: "dogomet"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "KANKAM",
        sousprefecture: "kankama"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "KINDO",
        sousprefecture: "kindoyé"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "KONIN",
        sousprefecture: "konindou"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "DEMA",
        sousprefecture: "n'déma"
      }, {
        prefectureCode: "DABO",
        sousprefectureCode: "ARFA",
        sousprefecture: "arfamoussaya"
      }, {
        comment: " --------------- DINGUIRAYE ---------------",
        prefectureCode: "DING",
        sousprefectureCode: "BANO",
        sousprefecture: "banora"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "DIALA-F",
        sousprefecture: "dialakoro faranah"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "DIATI",
        sousprefecture: "diatiféré"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "DING-CENT",
        sousprefecture: "dinguiraye-centre"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "GAGNA",
        sousprefecture: "gagnakali"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "KALINK",
        sousprefecture: "kalinko"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "KALLI",
        sousprefecture: "kallia"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "LANSA",
        sousprefecture: "lansanya"
      }, {
        prefectureCode: "DING",
        sousprefectureCode: "SELOU",
        sousprefecture: "sélouma"
      }, {
        comment: " --------------- Mandiana ---------------",
        prefectureCode: "MAND",
        sousprefectureCode: "BALAN",
        sousprefecture: "balandougouba"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "DIALA-K",
        sousprefecture: "dialakoro kankan"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "FARAL",
        sousprefecture: "faralako"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "KANTO",
        sousprefecture: "kantoumania"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "KINIE",
        sousprefecture: "kiniéran"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "KOUNDI",
        sousprefecture: "koundian"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "KOUNDIA",
        sousprefecture: "koundianakoro"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "MAND-CENT",
        sousprefecture: "mandiana-centre"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "MORO",
        sousprefecture: "morodou"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "NIANT",
        sousprefecture: "niantania"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "SALAD",
        sousprefecture: "saladou"
      }, {
        prefectureCode: "MAND",
        sousprefectureCode: "SANSAN",
        sousprefecture: "sansando"
      }, {
        comment: " --------------- Siguiri ---------------",
        prefectureCode: "SIGU",
        sousprefectureCode: "BANKON",
        sousprefecture: "bankon"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "DOKO",
        sousprefecture: "doko"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "FRANW",
        sousprefecture: "franwalia"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "KINIE",
        sousprefecture: "kiniébakoura"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "KINTIN",
        sousprefecture: "kintinian"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "MALE",
        sousprefecture: "maléah"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "NABOU",
        sousprefecture: "naboun"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "NIAGA",
        sousprefecture: "niagassola"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "NIAND",
        sousprefecture: "niandankoro"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "NORA",
        sousprefecture: "norassoba"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "SIGU-CENT",
        sousprefecture: "siguiri-centre"
      }, {
        prefectureCode: "SIGU",
        sousprefectureCode: "SIGUI",
        sousprefecture: "siguirini"
      }, {
        comment: " --------------- Coyah ---------------",
        prefectureCode: "COYA",
        sousprefectureCode: "KOUNDIA",
        sousprefecture: "coyah-centre"
      }, {
        prefectureCode: "COYA",
        sousprefectureCode: "KOURI",
        sousprefecture: "kouriah"
      }, {
        prefectureCode: "COYA",
        sousprefectureCode: "MANEA",
        sousprefecture: "manéah"
      }, {
        prefectureCode: "COYA",
        sousprefectureCode: "WONKI",
        sousprefecture: "wonkifong"
      }, {
        comment: " --------------- Dubréka ---------------",
        prefectureCode: "DUBR",
        sousprefectureCode: "BADI",
        sousprefecture: "badi"
      }, {
        prefectureCode: "DUBR",
        sousprefectureCode: "DUBR-CENT",
        sousprefecture: "dubréka-centre"
      }, {
        prefectureCode: "DUBR",
        sousprefectureCode: "FALES",
        sousprefecture: "falessade"
      }, {
        prefectureCode: "DUBR",
        sousprefectureCode: "KHOR",
        sousprefecture: "khorira"
      }, {
        prefectureCode: "DUBR",
        sousprefectureCode: "OUAS",
        sousprefecture: "ouassou"
      }, {
        prefectureCode: "DUBR",
        sousprefectureCode: "TANENE-DUBR",
        sousprefecture: "tanéné dubréka"
      }, {
        prefectureCode: "DUBR",
        sousprefectureCode: "TOND",
        sousprefecture: "tondon"
      }, {
        comment: " --------------- Forékaria ---------------",
        prefectureCode: "FORE",
        sousprefectureCode: "ALAS",
        sousprefecture: "alassoya"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "BENTY",
        sousprefecture: "benty"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "FARMO",
        sousprefecture: "farmoriah"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "FORE-CENT",
        sousprefecture: "forécariah-centre"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "KABAC",
        sousprefecture: "kaback"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "KAKOS",
        sousprefecture: "kakossa"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "KALIN",
        sousprefecture: "kalinko"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "KALLIA",
        sousprefecture: "kallia"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "MAFER",
        sousprefecture: "maférinya"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "MOUSS",
        sousprefecture: "moussayah"
      }, {
        prefectureCode: "FORE",
        sousprefectureCode: "SIKHO",
        sousprefecture: "sikhourou"
      }, {
        comment: " --------------- Kindia ---------------",
        prefectureCode: "KIND",
        sousprefectureCode: "BANG",
        sousprefecture: "bangouyah"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "DAMAN",
        sousprefecture: "damankanyah"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "FRIGUI",
        sousprefecture: "friguiagbé"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "KIND-CENT",
        sousprefecture: "kindia-centre"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "KOLEN",
        sousprefecture: "kolenté"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "MADI",
        sousprefecture: "madina-oula"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "MAMB",
        sousprefecture: "mambia"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "MOLOT",
        sousprefecture: "molota"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "SAMA",
        sousprefecture: "samayah"
      }, {
        prefectureCode: "KIND",
        sousprefectureCode: "SOUGUE",
        sousprefecture: "sougueta"
      }, {
        comment: " --------------- télimélé ---------------",
        prefectureCode: "TELI",
        sousprefectureCode: "BOUR",
        sousprefecture: "bourouwal"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "DARA",
        sousprefecture: "daramagnaky"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "GOUG",
        sousprefecture: "gougoudjé"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "KOBA-TELI",
        sousprefecture: "koba télimélé"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "KOLLET-TELI",
        sousprefecture: "kollet télimélé"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "KONSO",
        sousprefecture: "konsotamy"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "MISSIRA-TELI",
        sousprefecture: "missira télimélé"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "SANTO",
        sousprefecture: "santou"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "SARE",
        sousprefecture: "sarékaly"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "SINTA",
        sousprefecture: "sinta"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "SINTA",
        sousprefecture: "sinta"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "SOGOL",
        sousprefecture: "sogolon"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "TARIH",
        sousprefecture: "tarihoye"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "TELI-CENT",
        sousprefecture: "télimélé-centre"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "THION",
        sousprefecture: "thionthian"
      }, {
        prefectureCode: "TELI",
        sousprefectureCode: "TORM",
        sousprefecture: "tormélin"
      }, {
        comment: " --------------- lélouma ---------------",
        prefectureCode: "LELO",
        sousprefectureCode: "BALA",
        sousprefecture: "balaya"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "DIOUN",
        sousprefecture: "diountou"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "HERIC",
        sousprefecture: "hérico"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "KORBE",
        sousprefecture: "korbé"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "LAFOU",
        sousprefecture: "lafou"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "LELO-CENT",
        sousprefecture: "lélouma-centre"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "LINS-SAR",
        sousprefecture: "linsan saran"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "MANDA",
        sousprefecture: "manda"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "PARA",
        sousprefecture: "parawol"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "SAGAL",
        sousprefecture: "sagalé"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "TYANG",
        sousprefecture: "tyanguel-bori"
      }, {
        prefectureCode: "LELO",
        sousprefectureCode: "PETO",
        sousprefecture: "pétoye"
      }, {
        comment: " --------------- mali ---------------",
        prefectureCode: "MALI",
        sousprefectureCode: "BALA",
        sousprefecture: "balaki"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "DONGHO",
        sousprefecture: "donghol-sigon"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "DOUGOU",
        sousprefecture: "dougountouny"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "FOUGOU",
        sousprefecture: "fougou"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "GAYAH",
        sousprefecture: "gayah"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "HIDAY",
        sousprefecture: "hidayatou"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "LEBE",
        sousprefecture: "lébékére"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "MADI-WO",
        sousprefecture: "madina-wora"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "MALI-CENT",
        sousprefecture: "mali-centre"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "SALAM",
        sousprefecture: "salambandé"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "TELIR",
        sousprefecture: "téliré"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "TOUBA-MALI",
        sousprefecture: "touba mali"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "YIMB",
        sousprefecture: "yimbéring"
      }, {
        prefectureCode: "MALI",
        sousprefectureCode: "MADINA",
        sousprefecture: "madina"
      }, {
        comment: " --------------- tougué ---------------",
        prefectureCode: "TOUG",
        sousprefectureCode: "FATA",
        sousprefecture: "fatako"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "FELLO",
        sousprefecture: "fello-koundoua"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "KOIN",
        sousprefecture: "koïn"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "KOLAN",
        sousprefecture: "kolangui"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "KOLLET-TOUG",
        sousprefecture: "kollet tougué"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "KONA",
        sousprefecture: "konah"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "KOURA",
        sousprefecture: "kouratongo"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "TANGA",
        sousprefecture: "tangali"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "TOUG-CENT",
        sousprefecture: "tougué-centre"
      }, {
        prefectureCode: "TOUG",
        sousprefectureCode: "KANSAG",
        sousprefecture: "kansagui"
      }, {
        comment: " --------------- dalaba ---------------",
        prefectureCode: "DALA",
        sousprefectureCode: "BODIE",
        sousprefecture: "bodié"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "DALA-CENT",
        sousprefecture: "dalaba-centre"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "DITIN",
        sousprefecture: "ditinn"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "DAALA",
        sousprefecture: "kaala"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "KANKA",
        sousprefecture: "kankalabé"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "KEBA",
        sousprefecture: "kébali"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "KOBA-DALA",
        sousprefecture: "koba dalaba"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "MAFA",
        sousprefecture: "mafara"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "MITTY",
        sousprefecture: "mitty"
      }, {
        prefectureCode: "DALA",
        sousprefectureCode: "MOMB",
        sousprefecture: "mombéyah"
      }, {
        comment: " --------------- mamou ---------------",
        prefectureCode: "MAMO",
        sousprefectureCode: "BOULI",
        sousprefecture: "bouliwel"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "DOUN",
        sousprefecture: "dounet"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "GONGOR",
        sousprefecture: "gongoret"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "KEGNE",
        sousprefecture: "kégnéko"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "KOUK",
        sousprefecture: "konkouré"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "MAMO-CENT",
        sousprefecture: "mamou-centre"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "NYAGA",
        sousprefecture: "nyagara"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "OURE",
        sousprefecture: "ouré-kaba"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "PORED",
        sousprefecture: "porédaka"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "SARAM",
        sousprefecture: "saramoussaya"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "SOYAH",
        sousprefecture: "soyah"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "TEGUE",
        sousprefecture: "téguéréya"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "TIMB",
        sousprefecture: "timbo"
      }, {
        prefectureCode: "MAMO",
        sousprefectureCode: "TOLO",
        sousprefecture: "tolo"
      }, {
        comment: " --------------- pita ---------------",
        prefectureCode: "PITA",
        sousprefectureCode: "BANTI",
        sousprefecture: "bantignel"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "BOUR-TAP",
        sousprefecture: "bourouwal-tappé"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "DONGOL",
        sousprefecture: "dongol-touma"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "GONGORE",
        sousprefecture: "gongore"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "LEY-MI",
        sousprefecture: "ley-miro"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "MACI",
        sousprefecture: "maci"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "NINGU",
        sousprefecture: "ninguélandé"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "PITA-CENT",
        sousprefecture: "pita-centre"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "SANGAR",
        sousprefecture: "sangaréah"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "SINTALI",
        sousprefecture: "sintali"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "TIMBI-MADI",
        sousprefecture: "timbi-madina"
      }, {
        prefectureCode: "PITA",
        sousprefectureCode: "TIMBI-TOU",
        sousprefecture: "timbi-touny"
      }, {
        comment: " --------------- beyla ---------------",
        prefectureCode: "BEYL",
        sousprefectureCode: "BEYL-CENT",
        sousprefecture: "beyla-centre"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "BOOLA",
        sousprefecture: "boola"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "DIARA",
        sousprefecture: "diara-guerela"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "DIASS",
        sousprefecture: "diassodou"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "FOUALA",
        sousprefecture: "fouala"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "GBAKE",
        sousprefecture: "gbakedou"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "GBESS",
        sousprefecture: "gbessoba"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "KARALA",
        sousprefecture: "karala"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "KOUMA",
        sousprefecture: "koumandou"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "MOUSSA",
        sousprefecture: "moussadou"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "NIONS",
        sousprefecture: "nionsomoridou"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "SAMAN",
        sousprefecture: "samana"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "SINKO",
        sousprefecture: "sinko"
      }, {
        prefectureCode: "BEYL",
        sousprefectureCode: "SOKOU",
        sousprefecture: "sokourala"
      }, {
        comment: " --------------- guékédou ---------------",
        prefectureCode: "GUEC",
        sousprefectureCode: "BOLOD",
        sousprefecture: "bolodou"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "FANGA",
        sousprefecture: "fangamadou"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "GUEC-CENT",
        sousprefecture: "guéckédou-centre"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "GUEND",
        sousprefecture: "guendembou"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "KASSA",
        sousprefecture: "kassadou"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "KOUIN",
        sousprefecture: "kouindou"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "NONGOA",
        sousprefecture: "nongoa"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "OUEN",
        sousprefecture: "ouéndé-kénéma"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "TEKOUL",
        sousprefecture: "tékoulo"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "TERMIS",
        sousprefecture: "termessadou-dibo"
      }, {
        prefectureCode: "GUEC",
        sousprefectureCode: "BEIND",
        sousprefecture: "beindou"
      }, {
        comment: " --------------- lola ---------------",
        prefectureCode: "LOLA",
        sousprefectureCode: "BOSSO",
        sousprefecture: "bossou"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "FOUM",
        sousprefecture: "foumbadou"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "GAMA-BE",
        sousprefecture: "gama-béréma"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "GUEAS",
        sousprefecture: "guéassou"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "KOKO",
        sousprefecture: "kokota"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "LAINE",
        sousprefecture: "lainé"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "LOLA-CENT",
        sousprefecture: "lola-centre"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "NZOO",
        sousprefecture: "n'zoo"
      }, {
        prefectureCode: "LOLA",
        sousprefectureCode: "TOUNK",
        sousprefecture: "tounkarata"
      }, {
        comment: " --------------- macenta ---------------",
        prefectureCode: "MACE",
        sousprefectureCode: "BALIZ",
        sousprefecture: "balizia"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "BINI",
        sousprefecture: "binikala"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "BOFOS",
        sousprefecture: "bofossou"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "DARO",
        sousprefecture: "daro"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "FASSA",
        sousprefecture: "fassankoni"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "KOUAN",
        sousprefecture: "kouankan"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "KOYA",
        sousprefecture: "koyamah"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "MACE-CENT",
        sousprefecture: "macenta-centre"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "NZEBE",
        sousprefecture: "n'zébéla"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "OUREM",
        sousprefecture: "ourémaï"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "PANZI",
        sousprefecture: "panziazou"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "SENGB",
        sousprefecture: "sengbédou"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "SERED",
        sousprefecture: "sérédou"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "VASSE",
        sousprefecture: "vassérédou"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "WATAN",
        sousprefecture: "watanka"
      }, {
        comment: " --------------- nzérékoré ---------------",
        prefectureCode: "NZER",
        sousprefectureCode: "BOUNO",
        sousprefecture: "bounouma"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "GOUEC",
        sousprefecture: "gouécké"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "KOBELA",
        sousprefecture: "kobéla"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "KOROP",
        sousprefecture: "koropara"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "KOULE",
        sousprefecture: "koulé"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "NZER-CENT",
        sousprefecture: "n'zérékoré-centre"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "PALE",
        sousprefecture: "palé"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "SAMOE",
        sousprefecture: "samoé"
      }, {
        prefectureCode: "MACE",
        sousprefectureCode: "SOUL",
        sousprefecture: "soulouta"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "WOMEY",
        sousprefecture: "womey"
      }, {
        prefectureCode: "NZER",
        sousprefectureCode: "YALEN",
        sousprefecture: "yalenzou"
      }, {
        comment: " --------------- yomou ---------------",
        prefectureCode: "YOMO",
        sousprefectureCode: "BANIE",
        sousprefecture: "banié"
      }, {
        prefectureCode: "YOMO",
        sousprefectureCode: "BHEET",
        sousprefecture: "bheeta"
      }, {
        prefectureCode: "YOMO",
        sousprefectureCode: "BIGNA",
        sousprefecture: "bignamou"
      }, {
        prefectureCode: "YOMO",
        sousprefectureCode: "BOWE",
        sousprefecture: "bowé"
      }, {
        prefectureCode: "YOMO",
        sousprefectureCode: "DIECKE",
        sousprefecture: "diécké"
      }, {
        prefectureCode: "YOMO",
        sousprefectureCode: "PELA",
        sousprefecture: "péla"
      }, {
        prefectureCode: "YOMO",
        sousprefectureCode: "YOMO-CENT",
        sousprefecture: "yomou-centre"
      }],
      t = (r.getRegionsAndCodes = function () {
        return u;
      }, r.getRegions = function () {
        return u.map(function (e) {
          return e.region;
        });
      }, r.getRegionsCodes = function () {
        return u.map(function (e) {
          return e.code;
        });
      }, r.getRegionNameByCode = function (e) {
        var r = null;
        return u.map(function (u) {
          u.code === e && (r = u.region);
        }), r;
      }, r.getRegionCodeByName = function (e) {
        var r = null;
        return u.map(function (u) {
          u.region === e && (r = u.code);
        }), r;
      }),
      c = (r.getPrefecturesAndCodes = function () {
        return o;
      }, r.getPrefecturesCodes = function () {
        return o.map(function (e) {
          return e.prefectureCode;
        });
      }, r.getPrefectures = function () {
        return o.map(function (e) {
          return e.prefecture;
        });
      }, r.getPrefecturesAndCodesByRegionCode = function (e) {
        var r = [];
        return o.map(function (u) {
          u.regionCode === e && r.push(u);
        }), r;
      }, r.getPrefecturesByRegionCode = function (e) {
        var r = [];
        return o.map(function (u) {
          u.regionCode === e && r.push(u.prefecture);
        }), r;
      }, r.getPrefecturesByRegionName = function (e) {
        var r = t(e),
          u = [];
        return o.map(function (e) {
          e.regionCode === r && u.push(e.prefecture);
        }), u;
      }, r.getPrefectureNameByCode = function (e) {
        var r = null;
        return o.map(function (u) {
          u.prefectureCode === e && (r = u.prefecture);
        }), r;
      }, r.getPrefectureCodeByName = function (e) {
        var r = null;
        return o.map(function (u) {
          u.prefecture === e && (r = u.prefectureCode);
        }), r;
      });
    r.getSousprefecturesAndCodes = function () {
      return s;
    }, r.getSousprefecturesCodes = function () {
      return s.map(function (e) {
        return e.sousprefectureCode;
      });
    }, r.getSousprefectures = function () {
      return s.map(function (e) {
        return e.sousprefecture;
      });
    }, r.getSousprefecturesAndCodesByPrefectureCode = function (e) {
      var r = [];
      return s.map(function (u) {
        u.prefectureCode === e && r.push(u);
      }), r;
    }, r.getSousprefecturesByPrefectureCode = function (e) {
      var r = [];
      return s.map(function (u) {
        u.prefectureCode === e && r.push(u.sousprefecture);
      }), r;
    }, r.getSousprefecturesAndCodesByPrefectureName = function (e) {
      var r = c(e),
        u = [];
      return s.map(function (e) {
        e.prefectureCode === r && u.push(e);
      }), u;
    }, r.getSousprefecturesByPrefectureName = function (e) {
      var r = c(e),
        u = [];
      return s.map(function (e) {
        e.prefectureCode === r && u.push(e.sousprefecture);
      }), u;
    }, r.getSousprefectureNameByCode = function (e) {
      var r = null;
      return s.map(function (u) {
        u.sousprefectureCode === e && (r = u.sousprefecture);
      }), r;
    }, r.getSousprefectureCodeByName = function (e) {
      var r = null;
      return s.map(function (u) {
        u.sousprefecture === e && (r = u.sousprefectureCode);
      }), r;
    };
  }]);
});